'use strict';

module.exports = function() {
  return /url\(.*?\)/ig;
}



//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/functions/postcss/css-shorthand-expand/node_modules/css-url-regex/index.js
// module id = 983
// module chunks = 0